export function updateBasket(num) {
  const sidebarBasket = document.querySelector('.top-sidebar__count--cart');
  const headerBasket = document.querySelector('.center-header__count--cart');
  const headerMobileBasket = document.querySelector('.header-mobile__count--cart');

  const baskets = [sidebarBasket, headerBasket, headerMobileBasket];

  baskets.forEach((basket) => {
    if (basket === null) {
      return;
    }
    if (isSidebar(basket)) {
      updateStatus(basket, num);
    }
    updateCount(basket, num);
  });
}

function updateCount(elem, num) {
  num = Number(num);
  if (num === 0) {
    elem.classList.remove('active');
    elem.textContent = '';
  } else {
    elem.classList.add('active');
    elem.textContent = num;
  }
}

function isSidebar(elem) {
  return elem.classList.contains('top-sidebar__count');
}

function updateStatus(basket, num) {
  num = Number(num);
  const parent = basket.closest('.top-sidebar__item');
  const status = parent.querySelector('.top-sidebar__subtext');
  if (num === 0) {
    status.classList.remove('top-sidebar__subtext--active');
    status.textContent = 'пуста';
  } else {
    status.classList.add('top-sidebar__subtext--active');
    status.textContent = 'Перейти к оформлению заказа';
  }
}
